module.exports = __webpack_public_path__ + "img/team-robert-betancourt.36cf8434.png";